<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6">
              <h3>Leave Approval </h3>
            </div>
            <div class="col-sm-6 d-flex justify-content-end">
              <div class="edit" *ngIf="selectedCheckboxData.length > 0">
                <button type="button" title="Approve All" class="btn btn-sm" (click)="bulkUpdateStatus('Approved')">
                  <div>Approve</div>
                </button>
              </div>
              <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                <button type="button" title="Reject All" class="btn btn-sm" (click)="bulkUpdateStatus('Reject')">
                  <div>Reject</div>
                </button>
              </div>
              <div class="export">
                <button type="button" title="Export" data-bs-toggle="modal" data-bs-target="#exportLeaveModal">
                  <span><i class="ri-file-download-line"></i></span>
                </button>
              </div>
              <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                <button type="button" title="Edit" (click)="updateLeaveApp()">
                  <span><i class="ri-pencil-line"></i></span>
                </button>
              </div>
            </div>
          </div>
          <div style="display:none;">
            <ag-grid-angular #excelGrid style="margin: 15px; height: 500px;" (gridReady)="onExcelGridReady($event)"
              [columnDefs]="reportColumnDefs" [defaultColDef]="defaultColDef" [masterDetail]="true"
              [detailCellRendererParams]="detailCellRendererParams" (firstDataRendered)="onFirstDataRendered($event)"
              [defaultExcelExportParams]="defaultExcelExportParams" [excelStyles]="excelStyles">
            </ag-grid-angular>
            <ag-grid-angular #excelGrid2 style="margin: 15px; height: 500px;" (gridReady)="onExcelGridReady2($event)"
              [columnDefs]="reportColumnDefs" [defaultColDef]="defaultColDef" [masterDetail]="true"
              [detailCellRendererParams]="detailCellRendererParams2" (firstDataRendered)="onFirstDataRendered($event)"
              [defaultExcelExportParams]="defaultExcelExportParams2" [excelStyles]="excelStyles">
            </ag-grid-angular>
          </div>
        <!-- <div class="row">
          <div class="col-sm-8">
            <div class="canvas-data">
              <div class="row">
                <div class="col-sm-4 px-3 py-1">
                  <div class="input">
                    <div class="input-item">
                      <label class="floating-label">Employee Name</label>
                      <input
                            list=""
                            formControlName=""
                            placeholder="Employee Name"
                          />
                          <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 px-3 py-1">
                  <div class="input">
                    <div class="input-item">
                      <input
                            type="date"
                            formControlName=""
                            
                          />
                          <label class="floating-label-special">To</label>
                          <i class="ri-calendar-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 px-3 py-1">
                  <div class="input">
                    <div class="input-item">
                      <input
                            type="date"
                            formControlName=""
                            
                          />
                          <label class="floating-label-special">From</label>
                          <i class="ri-calendar-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
          <ag-grid-angular style="margin: 15px; height: 500px;"
                           class="ag-theme-material"
                           (gridReady)="onGridReady($event)"
                           [rowData]="rowData"
                           [columnDefs]="columnDefs"
                           pagination="true"
                           [defaultColDef]="defaultColDef"
                           [suppressRowClickSelection]="true"
                           [rowSelection]="rowSelection"
                           (rowSelected)="onRowSelect($event)"
                           (selectionChanged)="onSelectionChanged($event)"
                           paginationPageSize=10>
          </ag-grid-angular>
        </div>
      </section>
    </section>
  </article>
</main>




<!-- export leave report -->
<div class="modal fade" id="exportLeaveModal" tabindex="-1">
  <div class="modal-dialog">
      <div class="modal-content pl-5 pr-5">
          <form [formGroup]="leaveReport">
              <div class="modal-header">
                  <h5 class="modal-title">Extract Leave Report </h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div class="modal-body">
                  <div class="text-center">  
                      <div class="col-sm-4 px-3 py-1">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="startDate" type="date" required>
                                  <label for="startDate" class="floating-label">Start Date</label>
                                  <i class="ri-calendar-check-line"></i>
                              </div>
                          </div>
                      </div>

                      <div class="col-sm-4 px-3 py-1">
                          <div class="input">
                              <div class="input-item">
                                  <input formControlName="endDate" type="date" required>
                                  <label for="endDate" class="floating-label">End Date</label>
                                  <i class="ri-calendar-check-line"></i>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="modal-footer">
                  <button id="closeModalDeleteLeave" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" class="btn btn-primary" (click)="getLeaveReport()" >Submit</button>
              </div>
          </form>
      </div>
  </div>
</div>
